import React, { Component } from 'react';
import CustomInput from '../../../../../Utility/Components/CustomInput';
import AutosuggestComponent from '../../../../../Utility/Components/AutosuggestComponent';
import Button from 'react-bootstrap/Button';
import Config from '../../../../../Utility/Config'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import CustomButton from '../../../../../Utility/Components/CustomButton';
import ImageCropContent from '../../../../../Utility/Components/ImageCropContent';
import ErrorBoundary from '../../../../../Utility/Components/ErrorBoundary';
import ModalGlobal from '../../../../../Utility/Components/ModalGlobal';
import { useTranslation, withTranslation, Trans } from 'react-i18next';
import * as AdminGroupController from '../Controller/GroupController';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { loaderStateTrue, loaderStateFalse } from '../../../../../Actions/AllAction';
import { setToken, setUserCredentials, logOutApp } from '../../../../../GlobalModules/Login/Actions/LoginAction';
import HomeUtility from '../../../../Utility/Utility'
import Utility from '../../../../../Utility/Utility';
import { formatingAddworkerData } from '../DataFormat/AdminUserDataFormat'
import { getCurrentUser } from '../../../../../GlobalModules/Login/Controller/LoginController';
import ValidateUtility from '../../../../../GlobalModules/Utility/ValidateUtility';
import parsePhoneNumber from 'libphonenumber-js';

class AddEditUserGroupContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: null,
            crop: {
                unit: '%',
                width: 30,
                aspect: 1 / 1
            },
            croppedImageUrl: "",
            addProfileImagePreviewShow: false,
            addprofileImageSelected: require('../../../../../Utility/Public/images/profile-back.png'),
            addProfileImageError: "",
            actionModalflag: false,
            organisationList: [],
            travailleursFormData: {
                name: "",
                firstName: "",
                email: "",
                phone_number: "",
                profileImage: "",
                selectedOrganisation: "",
                user_type: "user"
            },
            traname: "",
            trafirstName: "",
            traemail: "",
            traphone_number: "",
            traprofileImage: "",
            traselectedOrganisation: [],
            user_type: "",

            //error state
            tranameError: "",
            firstNameError: "",
            emailError: "",
            phone_numberError: "",
            profileImageError: "",
            traselectedOrganisationError: "",
            user_typeError: "",


            trafirstNameError: "",
            traemailError: "",
            traphone_numberError: "",
            traprofileImageError: "",

            userTypeList: [
                { label: "Admin", value: 'admin' },
                { label: "User", value: 'user' },
            ],
            reserveFromData: {},
            handleChangeAction: false,
            userRoleType: [],
            user_roleError: "",

            branchList: [],
            branchSelectedValue: {},
            branchError: '',
            userRoleList: [],
            roleSelectedValue: {},
            phoneNumberCountryCode: "in",
            phoneNumberDialCode: "91"
        }

    }


    componentDidMount() {
        if (this.props.editedFlagUser) {
            this.setEditDataForAdminUser();
        }
        this.organisation();
        // this.getRoleList();

    }

    componentDidUpdate(prevProps) {
        if (this.props.clickedMemberData.id !== prevProps.clickedMemberData.id) {
            this.setEditDataForAdminUser();
            this.setState({
                handleChangeAction: false
            }, () => {
                //console.log("entry======other data click")
            })
        }
    }

    getRoleList = (selectedBranchId, hotelId = "") => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = this.props;
            let data = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["is_active"] = 1;
            globalQueryParamshash["branch_id"] = selectedBranchId
            if (hotelId != "") {
                globalQueryParamshash["hotel_id"] = hotelId
            }
            data['filters'] = JSON.stringify(globalQueryParamshash)
            loaderStateTrue();
            AdminGroupController.roleList(data).then((response) => {
                let roleArry = [];
                if (response.success) {
                    response.data.map((endata) => {
                        let roleHash = {};
                        roleHash['label'] = endata.name;
                        roleHash['value'] = endata.id;
                        roleArry.push(roleHash);
                    })
                    // this.setState({
                    //     userRoleList: roleArry
                    // })
                }
                resolve(roleArry)
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
        })
        return promise;
    }


    organisation = () => {
        const { loaderStateTrue, loaderStateFalse } = this.props;
        loaderStateTrue();
        let dataset = {};
        let filters = { "active": 1 }
        dataset['filters'] = JSON.stringify(filters);
        AdminGroupController.organisation(dataset).then((response) => {
            if (response.success) {
                let organisationArry = [];
                response.data.map((endata) => {
                    let organisationHash = {};
                    organisationHash['label'] = endata.name;
                    organisationHash['value'] = endata.id;
                    organisationHash['id'] = endata.id;
                    organisationArry.push(organisationHash);
                })
                this.setState({
                    organisationList: organisationArry
                }, () => {
                    if (['admin', 'user'].includes(this.props.userCredentials.user_details.user_type)) {
                        let organizationName = this.state.organisationList.find(org => org.value === this.props.userEntryType.org_id);
                        // setHotelSelectedValue([organizationName])
                        this.setState({
                            traselectedOrganisation: [organizationName]
                        }, () => {
                            if (['admin', 'user'].includes(this.props.userCredentials.user_details.user_type)) {
                                let hotelId = this.props.userEntryType?.org_id;
                                this.getHotelBranchListApi(hotelId);
                            }
                        })

                    }
                })
            }
            loaderStateFalse();
        }).catch((error) => {
            console.error("************error*************", error)
            if (error) {
                //Utility.toastNotifications(error.message, "Error", "error");
            }
            loaderStateFalse();
            if (error.message == "Network Error") {
            }
        });
    }

    getHotelBranchListApi = (hotelId = "") => {
        console.log('Entry')
        const { loaderStateTrue, loaderStateFalse } = this.props;
        let data = {};
        let filters = {};
        loaderStateTrue();
        let userType = this.props.userCredentials.user_details.user_type;
        if (hotelId != "") {
            data['org_id'] = hotelId
        }
        filters['filters'] = JSON.stringify(data);
        AdminGroupController.getOrgBranch(filters, userType, hotelId).then((response) => {
            let hotelBranchResponse = Object.keys(response.data).length > 0 && response.data[Object.keys(response.data)[0]]?.OrgBranchOrgRelation.length > 0 ? response.data[Object.keys(response.data)[0]].OrgBranchOrgRelation : {}
            let branchListData = [];
            let branchListObj = {};
            hotelBranchResponse.map((e) => {
                branchListObj = {};
                branchListObj['label'] = `${e.branch_name}`;
                branchListObj['value'] = e.id;
                branchListData.push(branchListObj)
            })
            if (branchListData.length > 0) {
                this.setState({
                    branchList: branchListData
                }, () => {
                    console.log('000000', this.props.editedFlagUser)
                    if (['admin', 'user'].includes(this.props.userCredentials.user_details.user_type) && this.state.branchList.length === 1 && !this.props.editedFlagUser) {
                        const selectedBranch = this.state.branchList[0];
                        this.setState({
                            branchSelectedValue: selectedBranch
                        })
                        const branchId = selectedBranch.value;
                        if (branchId) {
                            this.getRoleList(branchId).then((roleListData) => {
                                this.setState({
                                    userRoleList: roleListData.length > 0 ? roleListData : []
                                })
                            });
                        }
                    } else if (this.props.editedFlagUser) {
                        let userBranchRelationData = this.props.clickedMemberData.UserOrgRelation || [];
                        let branchId = userBranchRelationData[0]?.branch_id
                        let branchName = {
                            label: userBranchRelationData[0]?.branch_name || "",
                            value: userBranchRelationData[0]?.branch_id || "",
                        };
                        this.setState({
                            branchSelectedValue: branchName
                        }, () => {
                            if (branchId) {
                                this.getRoleList(branchId).then((roleListData) => {
                                    this.setState({
                                        userRoleList: roleListData.length > 0 ? roleListData : []
                                    }, () => {
                                        console.log('777777777777')
                                        if (this.props.editedFlagUser) {
                                            let userRoleRelationData = this.props.clickedMemberData.UserOrgRelation || [];
                                            let roleId = userBranchRelationData[0]?.role_id
                                            let roleName = {
                                                label: userRoleRelationData[0]?.role_name || "",
                                                value: userRoleRelationData[0]?.role_id || "",
                                            };
                                            this.setState({
                                                roleSelectedValue: roleName
                                            })
                                        }
                                    })
                                });
                            }
                        })
                    }
                })
            }

            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();

        });
    }

    addInputProfileImageChanged = (event) => {

        let { travailleursFormData } = this.state;
        let targetFileSplit = event.target.files[0].name.split('.');
        let lastElement = targetFileSplit.pop();
        let user_profile_image = {
            "file_name": "",
            "file_obj": ""
        };
        if (lastElement == 'JPEG' || lastElement == 'jpeg' || lastElement == 'jpg' || lastElement == 'JPG' || lastElement == 'png' || lastElement == 'PNG' || lastElement == '') {
            const fsize = event.target.files[0].size;
            const file = Math.round((fsize / 1024));
            if (file >= 300) {
                Utility.toastNotifications(this.props.t('imageUploadAlert'), "Warning", "warning");
            } else {
                this.setState({
                    imageCropModalFlag: true
                })
                if (event.target.files && event.target.files.length > 0) {
                    const reader = new FileReader();
                    reader.addEventListener('load', () =>
                        this.setState({ src: reader.result })
                    );
                    reader.readAsDataURL(event.target.files[0]);
                    user_profile_image["file_name"] = event.target.files[0].name
                    user_profile_image["file_obj"] = ""
                    travailleursFormData["profileImage"] = user_profile_image
                    this.setState({
                        travailleursFormData,
                        workerModalChange: true,
                        traprofileImageError: "",
                        addProfileImagePreviewShow: true,
                        addProfileImageError: ""
                    })
                }
            }
        } else {
            //travailleursFormData["profileImage"] = ""
            Utility.toastNotifications("Only allow png and jpg images.", "Warning", "warning");
            this.setState({
                //traprofileImageError: this.props.t('invalidField'),
                //addProfileImagePreviewShow: false,
                travailleursFormData,
                //addprofileImageSelected: 'Add Image',
                workerModalChange: true
            })
        }
    }

    checkIfOnlyNumbers = (str) => {
        // Check if the string contains only numbers
        if (/^\d+$/.test(str)) {
            return true; // The string contains only numbers
        } else {
            return false; // The string contains non-numeric characters
        }
    }

    travailleurHandleChange = (e) => {
        const { name, value } = e.target;
        const { travailleursFormData } = this.state;

        if (name == 'name') {
            if (value != "") {
                this.setState({
                    handleChangeAction: true,
                    traname: value,
                    tranameError: ""
                }, () => {
                    travailleursFormData['name'] = value.trim();
                })
            } else {
                this.setState({
                    traname: value,
                    handleChangeAction: true,
                    //tranameError: this.props.t('invalidField')
                }, () => {
                    travailleursFormData['name'] = value.trim();
                })
            }
        }

        if (name == 'firstName') {
            if (value != "") {
                this.setState({
                    handleChangeAction: true,
                    trafirstName: value,
                    trafirstNameError: ""
                }, () => {
                    travailleursFormData['firstName'] = value.trim();
                })
            } else {
                this.setState({
                    trafirstName: value,
                    handleChangeAction: true,
                    //trafirstNameError: this.props.t('invalidField')
                }, () => {
                    travailleursFormData['firstName'] = value.trim();
                })
            }
        }

        if (name == 'email') {
            travailleursFormData['email'] = value.trim();
            this.setState({
                traemail: value.trim(),
                traemailError: "",
                travailleursFormData
            })
        }

        if (name == 'phone_number') {

            if (value == "") {
                this.setState({
                    traphone_number: value,
                    // traphone_numberError: this.props.t('invalidField')
                }, () => {
                    travailleursFormData['phone_number'] = value;
                })
            } else {
                let phoneValidate = HomeUtility.validate_Phone_Number(value);
                //console.log("phoneValidate",phoneValidate)
                if (phoneValidate) {

                    this.setState({
                        traphone_number: value,
                        traphone_numberError: ""
                    }, () => {
                        travailleursFormData['phone_number'] = value;
                    })

                } else {
                    this.setState({
                        traphone_number: value,
                        traphone_numberError: ""
                    }, () => {
                        travailleursFormData['phone_number'] = value;
                    })

                }

            }
        }

        this.setState({
            travailleursFormData,
            workerModalChange: true
        })

    }

    handleChangeRoleFn = (type, event) => {
        const { travailleursFormData } = this.state;
        if (type == 'user_role') {
            this.setState({
                roleSelectedValue: event,
                user_roleError: "",
                handleChangeAction: true
            })
        }

        this.setState({
            travailleursFormData,
            workerModalChange: true
        })
    }

    handleChangeAlltravailleurSelected = (type, event) => {
        const { travailleursFormData } = this.state;
        // console.log("event.value", event.value)
        if (type == 'Organisation') {
            this.setState({
                traselectedOrganisation: event,
                traselectedOrganisationError: "",
            }, () => {
                travailleursFormData['selectedOrganisation'] = event;
            })
        }
        if (type == 'user_type') {
            this.setState({
                user_type: event,
                user_typeError: "",
            }, () => {
                travailleursFormData['user_type'] = event;
            })
        }

        if (type == 'org_branch') {
            this.setState({
                branchSelectedValue: event,
                branchError: "",
                userRoleList: [],
                handleChangeAction: true
            }, () => {
                const branchId = e.value;
                if (branchId) {
                    this.getRoleList(branchId).then((roleListData) => {
                        this.setState({
                            userRoleList: roleListData.length > 0 ? roleListData : []
                        })
                    });
                }
            })
        }

        this.setState({
            travailleursFormData,
            workerModalChange: true
        }, () => {
            // console.log("travailleursFormData=========", travailleursFormData)
        })
    }

    addWorkerDecisionMaker = () => {
        let valid = this.nextPagePermisionWorkerFormValid();
        // if (this.state.checkWorkerExistsFlag == true) {
        //     this.confirmationModalShow()
        // } else {
        //     this.addWorker()
        // }
        const { travailleursFormData } = this.state;
        // console.log("addWorkerDecisionMaker travailleursFormData===========", travailleursFormData)
        if (valid) {
            this.addWorker()
        }

    }

    nextPagePermisionWorkerFormValid = () => {
        const { travailleursFormData, userRoleType } = this.state;
        let valid = true;

        if (travailleursFormData.name.trim() == "") {
            this.setState({
                tranameError: this.props.t('invalidField')
            })
            valid = false;
        } else {
            const str = travailleursFormData.name.trim();
            const hasNumber = this.checkIfOnlyNumbers(str);
            if (hasNumber) {
                this.setState({
                    tranameError: this.props.t('OnlyNumberNotAllowed')
                })
                valid = false;
            } else {
                this.setState({
                    tranameError: ""
                })
            }
        }

        if (travailleursFormData.firstName.trim() == "") {
            this.setState({
                trafirstNameError: this.props.t('invalidField')
            })

            valid = false;
        } else {
            const str = travailleursFormData.firstName.trim();
            const hasNumber = this.checkIfOnlyNumbers(str);
            if (hasNumber) {
                this.setState({
                    trafirstNameError: this.props.t('OnlyNumberNotAllowed')
                })
                valid = false;
            } else {
                this.setState({
                    trafirstNameError: ""
                })
            }
        }

        if (travailleursFormData.email.trim() == "") {

            this.setState({
                traemailError: this.props.t('invalidField')
            })

            valid = false;
        } else {
            var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if (!expr.test(travailleursFormData.email)) {
                this.setState({
                    traemailError: this.props.t('validEmail')
                })
                valid = false;
            } else {
                this.setState({
                    traemailError: ""
                })
            }

        }

        // if (travailleursFormData.phone_number == "") {
        //     this.setState({
        //         traphone_numberError: this.props.t('invalidField')
        //     })

        //     valid = false;
        // } else {

        //     let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(Config.phoneNumberWithoutPlus + travailleursFormData.phone_number);
        //     // HomeUtility.validate_Phone_Number(travailleursFormData.phone_number);
        //     //console.log("phoneValidate",phoneValidate)
        //     if (phoneValidate) {
        //         this.setState({
        //             traphone_numberError: ""
        //         })
        //     } else {
        //         this.setState({
        //             traphone_numberError: this.props.t('validphonenumber')
        //         })

        //         valid = false;
        //     }
        // }

        if (travailleursFormData.phone_number == "" || travailleursFormData.phone_number == null) {
            this.setState({
                traphone_numberError: this.props.t('invalidField')
            })
            valid = false
        } else {
            let modifiedString = ValidateUtility.deleteAndBefore(travailleursFormData.phone_number, this.state.phoneNumberDialCode);
            let countryCodeValue = this.state.phoneNumberCountryCode.toUpperCase();
            const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
            if (phoneNumber && phoneNumber.isValid()) {
                this.setState({
                    traphone_numberError: ""
                })
            } else {
                this.setState({
                    traphone_numberError: this.props.t('validphonenumber')
                })
                valid = false
            }
        }



        // if (travailleursFormData.selectedOrganisation == "") {
        //     this.setState({
        //         traselectedOrganisationError: 'Required field'
        //     })
        //     valid = false;
        // } else {
        //     this.setState({
        //         traselectedOrganisationError: ""
        //     })
        // }

        if (Object.keys(this.state.roleSelectedValue).length == 0) {
            this.setState({
                user_roleError: 'Required field'
            })
            valid = false;
        } else {
            this.setState({
                user_roleError: ""
            })
        }

        // if (travailleursFormData.user_type == "") {
        //     this.setState({
        //         user_typeError: 'Required field'
        //     })
        //     valid = false;
        // } else {
        //     this.setState({
        //         user_typeError: ""
        //     })
        // }


        return valid;

    }

    addWorker = () => {
        let valid = this.nextPagePermisionWorkerFormValid();
        if (valid) {
            const { loaderStateTrue, loaderStateFalse, editedFlagUser } = this.props;
            const { travailleursFormData, reserveFromData, branchSelectedValue, roleSelectedValue } = this.state;
            if (this.props.editedFlagUser) {
                this.setState({
                    reserveFromData: {
                        name: travailleursFormData.name,
                        firstName: travailleursFormData.firstName,
                        phone_number: travailleursFormData.phone_number.substring(1, 13),
                    },
                })
            }
            let orgId = this.props.userEntryType.org_id;
            console.log('this.props.clickedMemberData----->', this.props.clickedMemberData)
            let userType = this.props.clickedMemberData.hasOwnProperty('user_type') && this.props.clickedMemberData.user_type ? this.props.clickedMemberData.user_type : '';
            // console.log("reserveFromData==========", reserveFromData)
            formatingAddworkerData(travailleursFormData, reserveFromData, editedFlagUser, branchSelectedValue, roleSelectedValue, orgId, userType).then((dataset_data) => {
                //let dataset_data = this.formatingAddworkerData();
                // console.log("editedFlagUser==========", editedFlagUser)

                let type = 'post';
                let id = ""
                let dataset = [dataset_data.user_details];

                if (this.props.editedFlagUser) {
                    id = this.props.editedIdUser;
                    type = "patch";
                    dataset = dataset_data.user_details;
                    //console.log("dataset middle========", dataset)
                }
                // console.log("dataset aaaaaaaa========", dataset)
                // return false;

                loaderStateTrue();
                AdminGroupController.userAddEdit(dataset, id, type).then((response) => {
                    loaderStateFalse();
                    if (type == "post") {
                        // console.log("entry post call========")
                        if (response.length > 0) {
                            // console.log("response========", response)
                            response.map((data, index) => {
                                if (data.success) {
                                    // let promiseArr = [
                                    //     this.workerRelationInsert(data, dataset_data.user_relation_info).then(() => {
                                    //     })
                                    // ]
                                    // Promise.all(promiseArr).then((responses) => {
                                    //     this.setState({ workerModalChange: false }, () => {
                                    //         this.closeTravailleursModal();
                                    //     })
                                    //     Utility.toastNotifications(data.message, "Success", "success");
                                    // })
                                    this.setState({ workerModalChange: false }, () => {
                                        this.closeTravailleursModal();
                                    })
                                    Utility.toastNotifications(data.message, "Success", "success");
                                    loaderStateFalse();
                                } else {
                                    Utility.toastNotifications(data.message, "Error", "error")
                                    loaderStateFalse();
                                }
                            })
                        }
                    } else {
                        if (response.success) {
                            if (this.props.editedIdUser == this.props.userCredentials.id) {
                                this.getCurrentUser();
                            }

                            this.setState({
                                workerModalChange: false,
                                handleChangeAction: false,
                            }, () => {
                                this.closeTravailleursModalForUpdate();
                            })
                            // Utility.toastNotifications(response.message, "Success", "success");
                            Utility.toastNotifications("Contact information has been updated successfully", "Success", "success");
                            loaderStateFalse();
                        } else {
                            Utility.toastNotifications(response.message, "Error", "error")
                            loaderStateFalse();
                        }
                    }
                }).catch((error) => {
                    console.error("************error*************", error)
                    if (error) {
                        //Utility.toastNotifications(error.message, "Error", "error");
                    }
                    loaderStateFalse();
                    if (error.message == "Network Error") {
                    }
                    if (error.response.status == 406) {
                        Utility.toastNotifications(error.response.data.message, "Error", "error");
                    }
                    if (error.response.status == 400) {
                        Utility.toastNotifications(error.response.data[0].message, "Error", "error");
                    }
                });
            });
        }
    }

    //get current user data fn
    getCurrentUser = () => {
        const { loaderStateTrue, loaderStateFalse, setUserCredentials } = this.props;
        getCurrentUser().then((response) => {
            if (response.success) {
                setUserCredentials(response.data)
            }
        }).catch((error) => {
            console.error("************error*************", error)
            loaderStateFalse();
        });
    }

    workerRelationInsert = (data, dataset) => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = this.props;
            dataset['user_id'] = data.data[0].id;
            loaderStateTrue();
            AdminGroupController.userRelationalDetailsAdd([dataset], 'post').then((response) => {
                loaderStateFalse();
                if (response.length > 0) {
                    resolve(response)
                    response.map((data, index) => {
                        if (data.success) {
                        } else {
                            Utility.toastNotifications(data.message, "Error", "error")
                        }
                    })
                }
            }).catch((error) => {
                //errorConsoleAdded
                console.error("************error*************", error)
                if (error) {
                }
                loaderStateFalse();
                if (error.message == "Network Error") {

                }
            });
        })
        return promise
    }

    closeTravailleursModal = () => {
        this.resetWorkerFrom();
        this.props.closeUserModal(false);

    }
    closeTravailleursModalForUpdate = () => {
        //this.resetWorkerFrom();
        this.props.isupdate(true);
    }

    resetWorkerFrom = () => {
        this.setState({
            travailleursFormData: {
                name: "",
                firstName: "",
                email: "",
                phone_number: "",
                profileImage: "",
                selectedOrganisation: "",
                user_type: "user"
            },
            user_type: "",
            traname: "",
            trafirstName: "",
            traemail: "",
            traphone_number: "",
            traprofileImage: "",
            traselectedOrganisation: [],
            //error state
            tranameError: "",
            firstNameError: "",
            emailError: "",
            phone_numberError: "",
            profileImageError: "",
            traselectedOrganisationError: "",
            user_typeError: "",
            userRoleType: [],
            user_roleError: "",

            addProfileImagePreviewShow: false,
            addprofileImageSelected: require('../../../../../Utility/Public/images/profile-back.png'),
            trafirstNameError: "",
            traemailError: "",
            traphone_numberError: "",
            traprofileImageError: "",
            workerModalChange: false,
            leaveTypeData: [],
            interimList: [],
            zoominzoomoutflag: "",

            branchList: [],
            branchSelectedValue: {},
            branchError: '',
            userRoleList: [],
            roleSelectedValue: {}

        })
    }

    phoneNumberInputHandleChangeFn = (phone_number, countryCode = {}) => {
        // const { traphone_number, travailleursFormData } = this.state;
        // let phoneNumberTemp = traphone_number
        // // console.log("phone_number======", phone_number)
        // if (phone_number != "") {
        //     let phoneValidate = HomeUtility.validate_Phone_Number_without_plus(phone_number);
        //     // console.log("phoneValidate======", phoneValidate)
        //     if (phoneValidate) {
        //         phoneNumberTemp = phone_number;
        //         this.setState({
        //             traphone_numberError: "",
        //             handleChangeAction: true
        //         }, () => {
        //             travailleursFormData['phone_number'] = phoneNumberTemp;
        //         })
        //     } else {
        //         phoneNumberTemp = phone_number;
        //         this.setState({
        //             phoneNumberError: "Enter valid phone number"
        //         })
        //     }
        // } else {
        //     phoneNumberTemp = "";
        //     this.setState({
        //         handleChangeAction: false
        //     })
        // }
        // this.setState({
        //     traphone_number: Config.phoneNumberWithOrwithoutPlus + '' + phoneNumberTemp
        // }, () => {
        //     //console.log("traphone_number==========", traphone_number)
        //     travailleursFormData['phone_number'] = Config.phoneNumberWithOrwithoutPlus + '' + phoneNumberTemp;
        // })


        const { traphone_number, travailleursFormData } = this.state;
        let phoneNumberTemp = traphone_number
        if (phone_number.trim() !== "") {
            let modifiedString = ValidateUtility.deleteAndBefore(phone_number, countryCode.dialCode);
            let countryCodeValue = countryCode.countryCode.toUpperCase();
            const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
            this.setState({
                phoneNumberCountryCode: countryCode.countryCode,
                phoneNumberDialCode: countryCode.dialCode
            })
            // setphoneNumberCountryCode(countryCode.countryCode)
            // setphoneNumberDialCode(countryCode.dialCode)
            if (phoneNumber && phoneNumber.isValid()) {
                phoneNumberTemp = phone_number;
                this.setState({
                    traphone_numberError: "",
                    handleChangeAction: true
                }, () => {
                    travailleursFormData['phone_number'] = phoneNumberTemp;
                })
            } else {
                phoneNumberTemp = phone_number;
                this.setState({
                    handleChangeAction: true,
                    phoneNumberError: "Enter valid phone number"
                })
            }
        } else {
            phoneNumberTemp = "";
            this.setState({
                handleChangeAction: true
            })
        }
        this.setState({
            traphone_number: Config.phoneNumberWithOrwithoutPlus + '' + phoneNumberTemp
        }, () => {
            travailleursFormData['phone_number'] = Config.phoneNumberWithOrwithoutPlus + '' + phoneNumberTemp;
        })
    }

    getBase64(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            //console.log('Error: ', error);
        };
    }

    onImageLoaded = (image) => {
        //console.log("onImageLoaded=====", image)
        this.imageRef = image;
    };

    onCropComplete = (crop) => {
        this.makeClientCrop(crop);
    };

    onCropChange = (crop, percentCrop) => {
        // You could also use percentCrop:
        // this.setState({ crop: percentCrop });
        this.setState({ crop });
    };

    async makeClientCrop(crop) {
        const { travailleursFormData } = this.state;
        if (this.imageRef && crop.width && crop.height) {
            const croppedImageUrl = await this.getCroppedImg(
                this.imageRef,
                crop,
                'newFile.jpeg'
            );
            let user_profile_image = {}
            this.setState({ addprofileImageSelected: croppedImageUrl }, () => {
                user_profile_image["file_name"] = this.state.travailleursFormData.profileImage.file_name
                user_profile_image["file_obj"] = this.state.addprofileImageSelected
                travailleursFormData["profileImage"] = user_profile_image
                this.setState({
                    travailleursFormData
                })
            });

        }
    }

    getCroppedImg = (image, crop, fileName) => {
        const canvas = document.createElement('canvas');
        const pixelRatio = window.devicePixelRatio;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        const base64Image = canvas.toDataURL('image/jpeg');
        //console.log("base64Image========",base64Image)
        return base64Image
    }

    //Image url crop

    imageCropModalShow = () => {
        this.setState({
            imageCropModalFlag: true
        })
    }

    imageCropModalHide = () => {
        const { travailleursFormData } = this.state;
        travailleursFormData["profileImage"] = ""
        this.setState({
            imageCropModalFlag: false,
            addprofileImageSelected: require('../../../../../Utility/Public/images/profile-back.png'),
            addProfileImageError: "",
            travailleursFormData,
            addProfileImagePreviewShow: false,
        })
    }

    imageCropDataSave = () => {
        this.setState({
            imageCropModalFlag: false,
            handleChangeAction: true
        })
    }

    setEditDataForAdminUser = () => {
        const { clickedMemberData } = this.props
        // console.log("clickedMemberData child========", clickedMemberData)
        this.setState({
            trafirstName: clickedMemberData.first_name.trim(),
            traname: clickedMemberData.last_name.trim(),
            traemail: clickedMemberData.email.trim(),
            traphone_number: clickedMemberData.contact_number.trim(),
            user_type: clickedMemberData.user_type != "" ? clickedMemberData.user_type : "",
            // traselectedOrganisation: clickedMemberData.org_id != "" ? { 'label': clickedMemberData.org_name.charAt(0).toUpperCase() + clickedMemberData.org_name.slice(1), 'value': clickedMemberData.org_id } : "",
            addprofileImageSelected: clickedMemberData.profile_img_url != null && clickedMemberData.profile_img_url != "" ? JSON.parse(clickedMemberData.profile_img_url).img_url : require('../../../../../Utility/Public/images/usericon.png'),
            addProfileImagePreviewShow: true,
            tranameError: "",
            trafirstNameError: "",
            traphone_numberError: "",

            travailleursFormData: {
                name: clickedMemberData.last_name,
                firstName: clickedMemberData.first_name,
                email: clickedMemberData.email,
                phone_number: clickedMemberData.contact_number.substring(1, 13),
                profileImage: "",
                // selectedOrganisation: clickedMemberData.org_id != "" ? { 'label': clickedMemberData.org_name.charAt(0).toUpperCase() + clickedMemberData.org_name.slice(1), 'value': clickedMemberData.org_id } : "",
                user_type: clickedMemberData.user_type != "" ? clickedMemberData.user_type : ""
            },

        }, () => {
            this.setState({
                reserveFromData: {
                    name: clickedMemberData.last_name,
                    firstName: clickedMemberData.first_name,
                    phone_number: clickedMemberData.contact_number.substring(1, 13),
                },
            })
            // console.log("travailleursFormData set edit data===========", this.state.travailleursFormData)
            // console.log("reserveFromData set edit data===========", this.state.reserveFromData)
            // console.log("addprofileImageSelected set edit data===========", this.state.addprofileImageSelected)
        })
        let userBranchRelationData = clickedMemberData.UserOrgRelation || [];
        let branchName = {
            label: userBranchRelationData[0]?.branch_name || "",
            value: userBranchRelationData[0]?.branch_id || "",
        };
        this.setState({
            branchSelectedValue: branchName
        })

        let userRoleRelationData = clickedMemberData.UserOrgRelation || [];
        let roleName = {
            label: userRoleRelationData[0]?.role_name || "",
            value: userRoleRelationData[0]?.role_id || "",
        };
        this.setState({
            roleSelectedValue: roleName
        })
    }


    render() {

        const { t, showSubmitBtn } = this.props;

        let roleName = this.props.userCredentials.hasOwnProperty('user_details') && this.props.userCredentials.user_details && this.props.userCredentials.user_details.hasOwnProperty('user_type') && this.props.userCredentials.user_details.user_type;
        // console.log("handleChangeAction render=======", this.state.handleChangeAction)
        // console.log("editedFlagUser render=======", this.props.editedFlagUser)
        return (
            <>
                <div className="modalinnerbody user-add-edit-box">
                    <div className="innerbodydimension">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <ErrorBoundary title="CustomInput Error">
                                                <CustomInput
                                                    parentClassName="input_field_inner"
                                                    labelName="First Name"
                                                    errorLabel={this.state.trafirstNameError}
                                                    name="firstName"
                                                    type="text"
                                                    value={this.state.trafirstName}
                                                    labelPresent={true}
                                                    onChange={this.travailleurHandleChange}
                                                    // readOnly={this.props.editedFlagUser}
                                                    // requiredStar={this.props.editedFlagUser ? false : true}
                                                    requiredStar={true}
                                                />
                                            </ErrorBoundary>
                                        </div>
                                        <div className="col-md-12">
                                            <ErrorBoundary title="CustomInput Error">
                                                <CustomInput
                                                    parentClassName="input_field_inner"
                                                    labelName="Last Name"
                                                    errorLabel={this.state.tranameError}
                                                    name="name"
                                                    type="text"
                                                    value={this.state.traname || ""}
                                                    labelPresent={true}
                                                    onChange={this.travailleurHandleChange}
                                                    // readOnly={this.props.editedFlagUser}
                                                    // requiredStar={this.props.editedFlagUser ? false : true}
                                                    requiredStar={true}
                                                />
                                            </ErrorBoundary>
                                        </div>

                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="user_add_img modprofile">
                                        <div className="userProfileImg">
                                            {!this.state.addProfileImagePreviewShow ?
                                                <label className="custom-file-upload">
                                                    <span className="filetext">
                                                        <img src={this.state.addprofileImageSelected} />  </span>
                                                    <span className="plusicon">
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                        <input type="file"
                                                            onChange={this.addInputProfileImageChanged} />
                                                    </span>
                                                </label>
                                                :
                                                <label className="custom-file-upload">
                                                    <img src={this.state.addprofileImageSelected} />
                                                    <span className="plusicon">
                                                        <i className="fa fa-plus" aria-hidden="true"></i>
                                                        <input type="file"
                                                            onChange={
                                                                this.addInputProfileImageChanged
                                                            } />
                                                    </span>
                                                </label>
                                            }

                                            <div className="col-md-12 errorClass error_div">{this.state.traprofileImageError}</div> </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6" style={{ paddingRight: 30 }}>
                                    <div className="dropdowninnerbox">
                                        <label>Organisation {this.props.editedFlagUser ? <span></span> : <span>*</span>}</label>
                                        <ErrorBoundary title="AutosuggestComponent Error">
                                            <AutosuggestComponent
                                                handleOnChange={this.handleChangeAlltravailleurSelected.bind(this, "Organisation")}
                                                options={this.state.organisationList}
                                                selectedValue={this.state.traselectedOrganisation}
                                                name=''
                                                isMulti={true}
                                                placeholder=""
                                                // isDisabled={this.props.editedFlagUser}
                                                isDisabled={true}
                                                isSearchable={true}
                                            />
                                        </ErrorBoundary>
                                        <div className="col-md-12 errorClass error_div">{this.state.traselectedOrganisationError}</div> </div>
                                </div>

                                {
                                    this.state.travailleursFormData.user_type == "user" ? <>
                                        {['admin', 'user'].includes(this.props.userCredentials.user_details.user_type) && this.state.branchList.length > 1 &&
                                            <div className="col-md-4">
                                                <div className="dropdowninnerboxContainer">
                                                    <label>Branch Name <span>*</span></label>
                                                    <ErrorBoundary title="AutosuggestComponent Error">
                                                        <AutosuggestComponent
                                                            handleOnChange={(e) => this.handleChangeAlltravailleurSelected(e, 'org_branch')}
                                                            options={this.state.branchList}
                                                            selectedValue={this.state.branchSelectedValue}
                                                            name=''
                                                            isMulti={false}
                                                            placeholder=""
                                                            isSearchable={true}
                                                            classNamePrefix="dropdown-default"
                                                            isDisabled={this.state.branchList.length == 1 ? true : false}
                                                        />
                                                    </ErrorBoundary>
                                                    <div className="col-md-12 errorClass error_div">{this.state.branchError}</div>
                                                </div>
                                            </div>}
                                        <div className="col-md-6">
                                            <div className="dropdowninnerbox">
                                                <label>Role {this.props.editedFlagUser ? <span></span> : <span>*</span>}</label>
                                                <ErrorBoundary title="AutosuggestComponent Error">
                                                    <AutosuggestComponent
                                                        handleOnChange={this.handleChangeRoleFn.bind(this, "user_role")}
                                                        options={this.state.userRoleList}
                                                        selectedValue={this.state.roleSelectedValue}
                                                        name=''
                                                        isMulti={false}
                                                        placeholder="Select role"
                                                        isSearchable={true}
                                                        id="user_role"
                                                    // isDisabled={this.props.editedFlagUser}
                                                    />
                                                </ErrorBoundary>
                                                <div className="col-md-12 errorClass error_div">{this.state.user_roleError}</div> </div>
                                        </div>
                                    </> : null
                                }

                                {/* <div className="col-md-6">
                                    <div className="dropdowninnerbox">
                                        <label>User type {this.props.editedFlagUser ? <span></span> : <span>*</span>}</label>
                                        <ErrorBoundary title="AutosuggestComponent Error">
                                            <AutosuggestComponent
                                                handleOnChange={this.handleChangeAlltravailleurSelected.bind(this, "user_type")}
                                                options={this.state.userTypeList}
                                                selectedValue={this.state.user_type}
                                                name=''
                                                isMulti={false}
                                                placeholder=""
                                                isSearchable={true}
                                                id="user_type"
                                                isDisabled={this.props.editedFlagUser}
                                            />
                                        </ErrorBoundary>
                                        <div className="col-md-12 errorClass error_div">{this.state.user_typeError}</div> </div>
                                </div> */}
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='row'>
                                <div className="col-md-6">
                                    <ErrorBoundary title="CustomInput Error">
                                        <CustomInput
                                            parentClassName="input_field_inner"
                                            labelName='Email'
                                            errorLabel={this.state.traemailError}
                                            name="email"
                                            type="text"
                                            value={this.state.traemail}
                                            labelPresent={true}
                                            onChange={this.travailleurHandleChange}
                                            id="worker_email"
                                            readOnly={this.props.editedFlagUser}
                                            requiredStar={this.props.editedFlagUser ? false : true}
                                        />
                                    </ErrorBoundary>
                                </div>
                                <div className="col-md-6">
                                    <div className='input_field_inner_phone'>
                                        <label className='input_field_inner_phone_label required_start_inner'>Phone Number
                                            {roleName != "user" &&
                                                <span className='required_start'>*</span>}
                                        </label>
                                        <ErrorBoundary title="PhoneInput Error">
                                            <PhoneInput
                                                disabled={roleName == "user" ? true : false}
                                                country={
                                                    this.state.phoneNumberCountryCode
                                                }
                                                value={this.state.traphone_number}
                                                onChange={(e, country) => this.phoneNumberInputHandleChangeFn(e, country)}
                                            />
                                        </ErrorBoundary>
                                        <div className="errorClass error_div">{this.state.traphone_numberError}</div> </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="col-md-12 text-center topspace">
                        {/* {roleName!= "user" && this.props.editedFlagUser || this.props.editedIdUser == this.props.userCredentials.id ? } */}

                        {showSubmitBtn ?
                            <button type="button" className={this.props.editedFlagUser ? "modbtn modbtnedit" : "modbtn"} onClick={this.addWorkerDecisionMaker}
                                disabled={this.props.editedFlagUser && !this.state.handleChangeAction ? true : false}
                            >{this.props.editedFlagUser ? "Save" : "Confirm"}</button>
                            : null}

                        {roleName == "admin" && this.props.editedFlagUser ?
                            <button type="button" className={this.props.editedFlagUser ? "modbtn modbtnedit" : "modbtn"} onClick={this.addWorkerDecisionMaker}
                                disabled={this.props.editedFlagUser && !this.state.handleChangeAction ? true : false}
                            >{this.props.editedFlagUser ? "Save" : "Confirm"}</button>
                            : null}

                        {roleName == "user" && this.props.editedIdUser == this.props.userCredentials.id ?
                            <button type="button" className={this.props.editedFlagUser ? "modbtn modbtnedit" : "modbtn"} onClick={this.addWorkerDecisionMaker}
                                disabled={this.props.editedFlagUser && !this.state.handleChangeAction ? true : false}
                            >{this.props.editedFlagUser ? "Save" : "Confirm"}</button>
                            : null}

                        {!showSubmitBtn && roleName == "app_admin" ?
                            <button type="button" className={this.props.editedFlagUser ? "modbtn modbtnedit" : "modbtn"} onClick={this.addWorkerDecisionMaker}
                                disabled={this.props.editedFlagUser && !this.state.handleChangeAction ? true : false}
                            >{this.props.editedFlagUser ? "Save" : "Confirm"}</button>
                            : null}

                        {!this.props.editedFlagUser ?
                            <button type="button" className="modbtn cancelbtn" id="cancel_worker_add_data"
                                onClick={this.closeTravailleursModal}
                            >Cancel</button> : null}
                    </div>
                </div>
                <ErrorBoundary title="ModalGlobal Error">
                    <ModalGlobal
                        show={this.state.imageCropModalFlag}
                        onHide={this.imageCropModalHide}
                        onCancel={this.imageCropModalHide}
                        onSave={this.imageCropDataSave}
                        className="modalcustomize cropmodalcontent"
                        bodyClassName="cropmodalcontentbody"
                        headerclassName="close_btn_icon"
                        title={t('cropimage')}
                        footer={true}
                        closeButton={true}
                        saveButtonLabel={t('crop')}
                        saveButtonClassName="delconfirmbtn btn btn-primary"
                        cancelButtonClassName="delcancelbtn btn btn-primary"
                        body={
                            <>
                                <ErrorBoundary title="ModalGlobal Error">
                                    <ImageCropContent
                                        onImageLoaded={this.onImageLoaded}
                                        onComplete={this.onCropComplete}
                                        onCropChange={this.onCropChange}
                                        crop={this.state.crop}
                                        croppedImageUrl={this.state.croppedImageUrl}
                                        src={this.state.src}
                                        onCropComplete={this.onCropComplete}
                                        imageCropModalShow={this.imageCropModalShow}
                                    />
                                </ErrorBoundary>
                            </>
                        }
                    />
                </ErrorBoundary>  </>
        )

    }
}

AddEditUserGroupContent.defaultProps = {
    showSubmitBtn: false
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        roleWisePermission: globalState.mainReducerData.roleWisePermission,
        userEntryType: globalState.LoginReducer.userEntryType,
    };
}

export default withRouter(connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setToken, setUserCredentials, logOutApp })(withTranslation()(AddEditUserGroupContent)));
